import { DVTJCUVWorkWithRecParentTabs } from "@pages/dvtjcuv/common/WorkWithRecTabs";
import WorkWithRecContent from "@pages/dvtjcuv/workwithrec/WorkWithRecContent";
import React, { useEffect, useState } from "react";

const WorkWithRecManager = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [currentParentTab, setCurrentParentTab] = useState(DVTJCUVWorkWithRecParentTabs.SEND_EMAIL_INVITE_JOB_TAB);
    const [runJobInfo, setRunJobInfo] = useState({
        email_tab: {}
    });

    const {runJob} = props;

    useEffect(() => {
        if (runJob) {
            setRunJobInfo({...runJob});
        }
    }, [runJob]);

    useEffect(() => {
        // #region agent log
        const currentHash = window.location.hash.substring(1);
        fetch('http://127.0.0.1:7242/ingest/1acfefc3-b3e5-4e98-9d11-0bbdd34fbaf7',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'WorkWithRecManager.js:22',message:'Hash sync useEffect entry',data:{currentHash:currentHash,currentParentTabId:currentParentTab.id},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'A'})}).catch(()=>{});
        // #endregion
        
        const syncTabFromHash = () => {
            // #region agent log
            const newHash = window.location.hash.substring(1);
            fetch('http://127.0.0.1:7242/ingest/1acfefc3-b3e5-4e98-9d11-0bbdd34fbaf7',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'WorkWithRecManager.js:26',message:'syncTabFromHash called',data:{newHash:newHash},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'A'})}).catch(()=>{});
            // #endregion
            Object.values(DVTJCUVWorkWithRecParentTabs).forEach(tab => {
                if (newHash && newHash === tab.id) {
                    // #region agent log
                    fetch('http://127.0.0.1:7242/ingest/1acfefc3-b3e5-4e98-9d11-0bbdd34fbaf7',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'WorkWithRecManager.js:29',message:'Tab matched from hash - setting state',data:{tabId:tab.id,hash:newHash},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'A'})}).catch(()=>{});
                    // #endregion
                    setCurrentParentTab(tab);
                }
            });
        };
        
        syncTabFromHash();
        
        // #region agent log
        const handleHashChange = () => {
            fetch('http://127.0.0.1:7242/ingest/1acfefc3-b3e5-4e98-9d11-0bbdd34fbaf7',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'WorkWithRecManager.js:38',message:'Hashchange event fired',data:{newHash:window.location.hash.substring(1)},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'C'})}).catch(()=>{});
            syncTabFromHash();
        };
        window.addEventListener('hashchange', handleHashChange);
        // #endregion
        
        return () => {
            window.removeEventListener('hashchange', handleHashChange);
        };
    }, []);

    const activeTab = (tab) => {
        if (currentParentTab.id === tab.id) {
            return 'active';
        }
        return '';
    };

    return (
        <div className="card card-default">
            <div className="card-header">
                <h3 className="card-title text-bold">WORK WITH REC</h3>
                <button type="button" className="btn btn-tool" data-card-widget="collapse">
                    <i className="fas fa-minus"/>
                </button>
                {/* <div className="card-tools pr-2 col-6">
                    <HeaderSearchButtons
                        showBtnSearchPipeline
                        showBtnSearchCdd
                        showBtnSearchReceiver
                        showBtnSearchEmployer
                    />
                </div> */}
            </div>
            <div className="card-body">
                <ul className='nav nav-tabs' role='tablist'>
                    {Object.values(DVTJCUVWorkWithRecParentTabs).map(tab => (
                        <li className='nav-item' key={tab.id}>
                            <a className={`nav-link ${activeTab(tab)}`} 
                               data-toggle='tab' 
                               href={`#${tab.id}`}
                               onClick={(e) => {
                                   // #region agent log
                                   fetch('http://127.0.0.1:7242/ingest/1acfefc3-b3e5-4e98-9d11-0bbdd34fbaf7',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'WorkWithRecManager.js:86',message:'Tab clicked',data:{tabId:tab.id,currentHash:window.location.hash,currentParentTabId:currentParentTab.id},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'C'})}).catch(()=>{});
                                   // #endregion
                                   e.preventDefault();
                                   window.location.hash = tab.id;
                                   // Hash change will trigger hashchange event, which calls syncTabFromHash()
                                   // #region agent log
                                   fetch('http://127.0.0.1:7242/ingest/1acfefc3-b3e5-4e98-9d11-0bbdd34fbaf7',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'WorkWithRecManager.js:90',message:'Hash set after click',data:{newHash:window.location.hash,tabId:tab.id},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'C'})}).catch(()=>{});
                                   // #endregion
                               }}>
                                {tab.title}
                            </a>
                        </li>
                    ))}
                </ul>
                <div className='tab-content'>
                    {Object.values(DVTJCUVWorkWithRecParentTabs).map((tab) => {
                        if (currentParentTab.id === tab.id) {
                            return (
                                <div id={tab.id} className={`tab-pane active`} key={tab.id}>
                                    <WorkWithRecContent 
                                        data={runJobInfo} 
                                        parentTab={tab}
                                        // onChangeRootTab={onTabClicked}
                                    />
                                </div>
                            );
                        }
                        return null;
                    })}
                </div>
            </div>
        </div>
    );
};

export default WorkWithRecManager; 